import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateMaterial({ username, onClose }) {
    const [loading, setLoading] = useState(false);
    const [MetalList, setMetalList] = useState([]);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        matt_id: "",
        purity: "",
        unit: "",
        price: "",
        reference: "",
        comment: "",
        user_transaction: username,
        color: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear error as user types
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getMetal();
    }, []);

    const validateFields = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Required field. Cannot be empty.";
        if (!formData.matt_id) newErrors.matt_id = "Required field. Cannot be empty.";
        if (!formData.purity) newErrors.purity = "Required field. Cannot be empty.";
        if (!formData.unit) newErrors.unit = "Required field. Cannot be empty.";
        if (!formData.price) newErrors.price = "Required field. Cannot be empty.";
        if (!formData.reference) newErrors.reference = "Required field. Cannot be empty.";
        return newErrors;
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/materials/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created successfully!',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/materials');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Material already exists. Please try another name.',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);
            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Material</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className="btn btn-warning" to="/materials" onClick={onClose}>Go Back</Link>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                            placeholder="Enter material name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>

                                    <div className="col-6 mb-3">
                                        <label htmlFor="matt_id" className="form-label">Material Type</label>
                                        <select
                                            className={`form-select ${errors.matt_id ? "is-invalid" : ""}`}
                                            name="matt_id"
                                            value={formData.matt_id}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select metal type</option>
                                            {MetalList.map((Metal_R) => (
                                                <option key={Metal_R.matt_ID} value={Metal_R.matt_ID}>
                                                    {Metal_R.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.matt_id && <div className="invalid-feedback">{errors.matt_id}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="purity" className="form-label">Purity</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.purity ? "is-invalid" : ""}`}
                                            placeholder="Enter purity"
                                            name="purity"
                                            value={formData.purity}
                                            onChange={handleChange}
                                        />
                                        {errors.purity && <div className="invalid-feedback">{errors.purity}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="unit" className="form-label">Unit</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.unit ? "is-invalid" : ""}`}
                                            placeholder="Enter unit"
                                            name="unit"
                                            value={formData.unit}
                                            onChange={handleChange}
                                        />
                                        {errors.unit && <div className="invalid-feedback">{errors.unit}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="price" className="form-label">Price</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.price ? "is-invalid" : ""}`}
                                            placeholder="Enter price"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleChange}
                                        />
                                        {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="reference" className="form-label">Reference</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.reference ? "is-invalid" : ""}`}
                                            placeholder="Enter reference"
                                            name="reference"
                                            value={formData.reference}
                                            onChange={handleChange}
                                        />
                                        {errors.reference && <div className="invalid-feedback">{errors.reference}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="color" className="form-label">Color</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color"
                                            id="color"
                                            name="color"
                                            value={formData.color}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Xero Item Code</label>
                                        <input
                                            type='text'
                                            className="form-control"
                                            placeholder="Enter the item ID as a Xero reference"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></input>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create"}
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateMaterial;
